import React from 'react';
import { Link } from 'react-router-dom';
import {
    FaBookOpen,
    FaChevronRight,
    FaFlask,
    FaHandHoldingHeart,
    FaLaptop,
    FaMapMarkerAlt,
} from 'react-icons/fa';
import styles from './nutri_marimurra.module.scss';
import Perfil from './src/perfil.jpg';
import { WHATSAPP_ONLINE, WHATSAPP_PRESENCIAL, getWhatsappUrl } from './dados_nutri_marimurra.ts';

type LinkItem = {
    titulo: string;
    descricao: string;
    icon: React.ReactNode;
    href?: string;
    to?: string;
};

const LINKS: LinkItem[] = [
    {
        titulo: 'Agendar consulta online',
        descricao: 'Atendimento por videochamada',
        icon: <FaLaptop />,
        href: getWhatsappUrl(
            WHATSAPP_ONLINE,
            'Olá, Mariana! Vim pelo Instagram e gostaria de agendar uma consulta online.'
        ),
    },
    {
        titulo: 'Agendar consulta presencial',
        descricao: 'Atendimento no consultório',
        icon: <FaMapMarkerAlt />,
        href: getWhatsappUrl(
            WHATSAPP_PRESENCIAL,
            'Olá, Mariana! Vim pelo Instagram e gostaria de agendar uma consulta presencial.'
        ),
    },
    {
        titulo: 'Terapia alimentar',
        descricao: 'Para crianças com dificuldade alimentar',
        icon: <FaHandHoldingHeart />,
        to: '/nutri_marimurra/terapia-alimentar',
    },
    {
        titulo: 'Cursos e materiais',
        descricao: 'Cursos, e-books e aulas',
        icon: <FaBookOpen />,
        to: '/nutri_marimurra/cursos',
    },
    {
        titulo: 'Conteúdos',
        descricao: 'Currículo, artigos e entrevistas',
        icon: <FaFlask />,
        to: '/nutri_marimurra/conteudos',
    },
];

const Nutri_marimurra: React.FC = () => {
    return (
        <div className={styles.nutri_marimurra}>
            <div className={styles.page}>
                <div className={styles.hero}>
                    <img className={styles.heroImg} src={Perfil} alt="Mariana Murra, nutricionista" />
                    <div className={styles.heroFade} />
                </div>

                <div className={styles.intro}>
                    <p className={styles.eyebrow}>Nutricionista</p>
                    <h1 className={styles.name}>Mariana Murra</h1>
                    <p className={styles.credentials}>Pesquisadora | Mestre em Oncologia</p>
                    <span className={styles.divider} />
                    <p className={styles.tagline}>
                        Te trago <em>ciência e leveza</em> na alimentação infantil
                    </p>
                </div>

                <nav className={styles.links}>
                    {LINKS.map((item) => {
                        const conteudo = (
                            <>
                                <span className={styles.linkIcon}>{item.icon}</span>
                                <span className={styles.linkText}>
                                    <span className={styles.linkTitle}>{item.titulo}</span>
                                    <span className={styles.linkDesc}>{item.descricao}</span>
                                </span>
                                <FaChevronRight className={styles.linkArrow} />
                            </>
                        );

                        return item.to ? (
                            <Link key={item.titulo} to={item.to} className={styles.link}>
                                {conteudo}
                            </Link>
                        ) : (
                            <a
                                key={item.titulo}
                                href={item.href}
                                className={styles.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {conteudo}
                            </a>
                        );
                    })}
                </nav>

                <footer className={styles.footer}>Mariana Murra · Nutrição Infantil</footer>
            </div>
        </div>
    );
};

export default Nutri_marimurra;
